// 附件網址解析:DB 內保存的是「當初上傳時」的完整 blob 網址,
// 儲存體帳戶搬遷後,舊網址的帳戶名稱已不是現行帳戶。
// 這裡只把「主機名稱」換成現行帳戶,容器與路徑完全沿用 —— 因此 DB 不需異動。
// (檔案已用 server-side copy 搬到新帳戶的相同路徑)
const BLOB_SUFFIX = ".blob.core.windows.net";
const CURRENT_ACCOUNT = process.env.REACT_APP_BLOB_ACCOUNT || "eipbackendstorage1";

export const toFileUrl = (url) => {
  if (!url || typeof url !== "string") return url;
  let parsed;
  try {
    parsed = new URL(url);
  } catch (e) {
    return url; // 非絕對網址(例如 mock 資料)原樣返回
  }
  const host = parsed.hostname.toLowerCase();
  if (!host.endsWith(BLOB_SUFFIX)) return url; // 非 blob 網址不動
  parsed.hostname = CURRENT_ACCOUNT + BLOB_SUFFIX;
  return parsed.toString();
};

export default toFileUrl;

// 附件存放於公司儲存體,僅允許公司內部網路存取。
// 於外部網路開啟時會被網路層阻擋,此時顯示下列提示,而非無止盡載入。
export const FILE_OFFNET_HINT = "此附件僅能於公司內部網路開啟,請連線公司網路或 VPN 後再試。";
